<template>
  <BaseButton
    v-bind="$attrs"
    :size="size"
    background-colour="gradient"
    @click="$emit('click')"
  >
    <template v-if="preloadIcons">
      <LoadingSpinner
        v-show="isLoading"
        size="small"
        :colour="iconColour"
        :class="bem('icon')"
      />
      <VisionIcon
        v-show="!isLoading && isComplete"
        icon="checkmark"
        size="x-small"
        :class="bem('icon')"
      />
    </template>
    <template v-else>
      <LoadingSpinner
        v-if="isLoading"
        size="small"
        :colour="iconColour"
        :class="bem('icon')"
      />
      <VisionIcon
        v-else-if="isComplete"
        icon="checkmark"
        size="x-small"
        :class="bem('icon')"
      />
    </template>

    <template #content>
      <slot />
    </template>
  </BaseButton>
</template>

<script>
import { mapState } from 'pinia'

export default {
  name: 'PrimaryButton',

  props: {
    noTheme: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isComplete: { type: Boolean, default: false },
    preloadIcons: { type: Boolean, default: false },
    theme: { type: String, default: 'gradient' },
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return ['large', 'regular', 'medium', 'small', 'xs', 'x-small'].includes(value)
      },
    },
  },

  emits: ['click'],

  setup() {
    return {
      bem: useBEM('PrimaryButton')
    }
  },

  computed: {
    ...mapState(usePageStore, ['pageTheme']),

    iconColour() {
      if (this.pageTheme === 'ln4') return 'off-black'
      return 'white'
    },
  },
}
</script>

<style lang="postcss">
.PrimaryButton {
  &__icon {
    margin-right: 0.5rem;
    margin-bottom: 1px;
  }
}
</style>
